import { render, staticRenderFns } from "./EncaminharProcessosAtaDirex.vue?vue&type=template&id=50e22994"
import script from "./EncaminharProcessosAtaDirex.vue?vue&type=script&lang=js"
export * from "./EncaminharProcessosAtaDirex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports